export const DEFAULT_OPTIONS = ["desktop", "mobile"];
